import { Link, Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { ICustomTheme } from 'interfaces';

export const StyledDivider = styled('span')(
  ({ theme }: { theme: ICustomTheme }) => ({
    border: `1px solid ${theme.colors.paletteFromBO.main}`,
    display: 'inline-block',
    height: theme.spacing(1.5),
    margin: theme.spacing(0, 2),
    position: 'relative',
    top: 1,
  }),
);

export const StyledTypography = styled(Typography)(
  ({ theme }: { theme: ICustomTheme }) => ({
    color: theme.colors.paletteFromBO.main,
  }),
);

export const StyledCopyright = styled(Typography)(
  ({ theme }: { theme: ICustomTheme }) => ({
    color: theme.colors.paletteFromBO.main,
    marginTop: theme.spacing(2),
  }),
);

export const StyledLink = styled(Link)(
  ({ theme }: { theme: ICustomTheme }) => ({
    color: theme.colors.paletteFromBO.main,
  }),
);
